import Navbar from "../../../components/feature/Navbar";
import Footer from "../../../components/feature/Footer";
import ArticleHero from "./components/ArticleHero";
import ArticleContentFirstHalf from "./components/ArticleContentFirstHalf";
import ArticleContentSecondHalf from "./components/ArticleContentSecondHalf";
import ArticleFormula from "./components/ArticleFormula";
import ArticleShopSection from "./components/ArticleShopSection";
import ArticleRelated from "./components/ArticleRelated";
import ArticleBottomCTA from "./components/ArticleBottomCTA";

export default function SoftBeigePage() {
  return (
    <div className="min-h-screen bg-[#FDFAF5]" style={{ fontFamily: "'Inter', sans-serif" }}>
      <Navbar />
      <main>
        <ArticleHero />
        <div className="max-w-screen-xl mx-auto px-8 md:px-16">
          <ArticleContentFirstHalf />
          <ArticleContentSecondHalf />
          <ArticleFormula />
          <ArticleShopSection />
        </div>
        <ArticleRelated />
        <ArticleBottomCTA />
      </main>
      <Footer />
    </div>
  );
}
